import { useState,useEffect, useRef } from 'react'
import {url,url2} from '../Componentes/Const'

export function Informes(){
    const [empleados,setEmpleados] = useState([])
    const [empleado,setEmpleado] = useState([])
    const [anio, setAnio] = useState([])
    const [years,setYears ] = useState([]);
    const ref_empleado = useRef()
    const ref_anio = useRef()
    const [enlace, setEnlace] = useState([])
    const enlaceShow = false;
    function cargar(){
        const requestOptions = {
            method: "GET",
            header :{
                "Content-Type" : "application/json"
            }
        }
        fetch(url2 +"/personas", requestOptions)
        .then(response => response.json())
        .then(data => { console.log(data)
            setEmpleados(data)
            const currentYear = new Date().getFullYear();
            for (let year = 2023; year <= currentYear; year++) {
                years.push(year);console.log("año",year);
            }
            setYears(years)
        })
        .catch(error=> console.log(error))

        
    }
    useEffect(()=>{ 
        cargar()
    },[])

    const handleEmpleado = ()=>{
        setEmpleado(ref_empleado.current.value)
    }

    const handleAnio = ()=>{
        setAnio(ref_anio.current.value)
    }

    const handleCargar=()=>{
        const persona_id = empleado
        
        // window.open(url + "/informes/Devengados1.php?persona_id=" + empleado+"& tipo=xls","_blank","no_referrer")
        window.open(url + "/informes/Devengados1.php?persona_id=" + empleado+"&anio="+ anio +"","_blank","no_referrer")

    }


    return (<>
        <div className='container'>
            {/* <div className='row'>
                <div className='col-3'>
                    <a href={`${url}/nomina/NominaGeneralHoja.php`} target="_blank" className="btn btn-outline-info btn-sm" >Consolidado</a>
                </div>
            </div> */}
            <div className='row'>
                <div className='col-6'>
                <form>
                    <h2>Informe Devengados Empleados</h2>
                    <div class="form-group"> 
                    <label>Seleccione empleado:</label>
                    <select className="form-select" ref={ref_empleado} onChange={handleEmpleado}>
                        <option value="0" >Seleccione</option>
                        {
                            empleados.map(dato=>(
                                <option value={dato.id} >{dato.nombre} - Nv. {dato.nivel_id}</option>
                            ))
                        }        
                    </select>
                    </div>
                    <div>
                        <label>Año:</label>
                        <select ref={ref_anio} onChange={ handleAnio } className="form-select">
                        <option value="0" >Seleccione</option>
                        {years.map((year) => (
                            <option key={year} value={year}>
                            {year}
                            </option>
                        ))}
                        </select>
                    </div>
                    <div class="form-group">
                    { enlaceShow ? (<a  href={`/tablero/nominaDetalle/${enlace}`} >Descargar</a>) 
                    : (<></>) }    
                    </div>
                    <div class="form-group my-4">
                        <button className="btn btn-info" onClick={ handleCargar }>
                            Cargar
                        </button>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </>)
}